import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { poughkeepsieConfig } from "./data";

export default function PoughkeepsiePage() {
  return <CityPageTemplate config={poughkeepsieConfig} />;
}